module.exports = __webpack_public_path__ + "static/media/linkedin.1425565e.svg";